/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const jiraStatusModelSchema = z.object({
  id: z.string(),
  name: z.string(),
});
